import { Dismiss24Regular, Send20Regular } from '@/components/Icon'
import { IconButton } from '@mui/material'
import Tooltip from '@/components/Tooltip'
import AiAskBarEmailReplyToolbar from './AiAskBarEmailReplyToolbar'
import styles from './index.module.scss'

export default function AiAskBarRightActionsEmailReply({
  attachments,
  handleOpenFilePicker,
  handleSend,
  sendDisabled,
  sendIsActive,
  isSendPulsing,
  onDiscard,
}) {
  return (
    <>
      <AiAskBarEmailReplyToolbar attachments={attachments} handleOpenFilePicker={handleOpenFilePicker} />
      <Tooltip text="Send" placement="top">
        <IconButton
          type="button"
          className={`${styles.circleAction} ${styles.circleActionSend}${sendIsActive ? ` ${styles.circleActionSendActive}` : ''}${isSendPulsing ? ` ${styles.circleActionSendPulse}` : ''}`}
          onClick={handleSend}
          aria-label="Send"
          disabled={sendDisabled}
        >
          <Send20Regular className={styles.circleIcon} aria-hidden />
        </IconButton>
      </Tooltip>
      {onDiscard ? (
        <Tooltip text="Discard draft" placement="top">
          <IconButton
            type="button"
            className={styles.emailReplyDiscard}
            onClick={onDiscard}
            aria-label="Discard draft"
          >
            <Dismiss24Regular className={styles.circleIcon} aria-hidden />
          </IconButton>
        </Tooltip>
      ) : null}
    </>
  )
}
